import { render, staticRenderFns } from "./JdpCandidateProfile.vue?vue&type=template&id=562e3398&"
import script from "./JdpCandidateProfile.vue?vue&type=script&lang=ts&"
export * from "./JdpCandidateProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports